import React from 'react';
import PropTypes from 'prop-types';

class SMCalendarSelectBox extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: this.props.selectedValue,
    };
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({selectedValue : nextProps.selectedValue});
  }
  
  didChangeValue(e) {
    if (this.props.delegate && typeof this.props.delegate.calendarSelectBoxValueDidChange === 'function'){
      let ym = e.currentTarget.value.split(','),
          year = parseInt(ym[0]),
          month = parseInt(ym[1]);
      this.props.delegate.calendarSelectBoxValueDidChange(year, month);
      this.setState({selectedValue : e.currentTarget.value});
    }
  }

  render() {
    let options = [];
    for (let i = 0; i < this.props.items.length; i++) {
      let item = this.props.items[i];
      options.push(<option key={item.value} value={item.value}>{item.label}</option>);
    }
    
    return (
      <select name={this.props.name} value={this.state.selectedValue} onChange={this.didChangeValue.bind(this)} 
        className={this.props.options.className}>
        {options}
      </select>
    );
  }
}
SMCalendarSelectBox.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  delegate: PropTypes.object,
  selectedValue: PropTypes.any,
  options: PropTypes.object
};
SMCalendarSelectBox.defaultProps = {
  options: {
    className: "w140",
  }
};
export default SMCalendarSelectBox;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/calendar/SMCalendarSelectBox.jsx